import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'notice-info-snackbar',
    templateUrl: './notice-info-snackbar.component.html',
    styleUrls: ['./notice-info-snackbar.component.scss'],
    standalone: false
})
export class NgxNoticeInfoSnackbarComponent {
    icon: string;
    message: string;

    constructor (@Inject(MAT_SNACK_BAR_DATA) public data: any) {
        this.icon = data.icon ? data.icon : 'check_circle';
        this.message = data.message || 'Success!';
    }
}
